<template>
  <div class="modal-mask">
    <div class="modal-wrapper">
      <div class="loading-simple-container">
        <svg class="loading-draw-svg" :viewBox="markViewBox" xmlns="http://www.w3.org/2000/svg">
          <path class="loading-draw-path" fill-rule="evenodd" clip-rule="evenodd" :d="markPath"/>
        </svg>
      </div>
    </div>
  </div>
</template>

<style lang="scss">
.modal-mask {
  position: fixed;
  z-index: 999822;
  top: 0;
  left: 0;
  width: 100%;
  height: 100vh;
  background-color: #fff;
  display: table;
  transition: opacity 0.3s ease;
  overflow: hidden;
}

.modal-wrapper {
  display: table-cell;
  vertical-align: middle;
  height: 100vh;
}

.loading-simple-container {
  width: 70px;
  margin: 0px auto;
  transition: all 0.3s ease;
}

.loading-draw-svg {
  width: 100%;
  height: auto;
  overflow: visible;
}

.loading-draw-path {
  fill: #5D0085;
  fill-opacity: 0;
  stroke: #5D0085;
  stroke-width: 2.5;
  stroke-linecap: round;
  stroke-linejoin: round;
  stroke-dasharray: 700;
  stroke-dashoffset: 700;
  animation: loading-draw 2.6s ease-in-out infinite;
}

@keyframes loading-draw {
  0% {
    stroke-dashoffset: 700;
    fill-opacity: 0;
  }
  40% {
    stroke-dashoffset: 0;
    fill-opacity: 0;
  }
  55% {
    stroke-dashoffset: 0;
    fill-opacity: 1;
  }
  75% {
    stroke-dashoffset: 0;
    fill-opacity: 1;
  }
  90% {
    stroke-dashoffset: 0;
    fill-opacity: 0;
  }
  100% {
    stroke-dashoffset: 700;
    fill-opacity: 0;
  }
}

.modal-simple-footer {
  background-color: #fff;
  width: 100%;
  height: fit-content;
  padding: 10px 0;
  display: flex;
  justify-content: center;
  align-items: center;
  border-top: 1px solid #e0e0e0;
  border-bottom-left-radius: 5px;
  border-bottom-right-radius: 5px;
}

.modal-simple-default-button {
  background-color: #007bff;
  color: #ffffff;
  border: none;
  padding: 10px 30px;
  border-radius: 30px;
}

.modal-header-simple {
  text-align: center;
  padding: 20px 30px 0 30px;
}

.modal-header-simple h4 {
  margin-top: 0;
  color: #8a6d3b;
  font-weight: bold;
}

.modal-simple-body {
  margin: 0 30px;
  width: fit-content;
  padding: 0;
  text-align: center;
}

.modal-simple-body p {
  font-size: 1.7rem;
  font-weight: 500;
  color: #212529;
  font-family: normal, Open Sans;
  @media (max-width: 767px) {
    font-size: 1.5rem;
  }
}

.modal-default-button {
  float: right;
}

.modal-enter {
  opacity: 0;
}

.modal-leave-active {
  opacity: 0;
}

.modal-enter .modal-container,
.modal-leave-active .modal-container {
  -webkit-transform: scale(1.1);
  transform: scale(1.1);
}
</style>

<script>
import { MOVE_MAIS_MARK_PATH, MOVE_MAIS_MARK_VIEWBOX } from "../../../assets/brand-mark.js";

export default {
  data() {
    return {
      markPath: MOVE_MAIS_MARK_PATH,
      markViewBox: MOVE_MAIS_MARK_VIEWBOX,
    };
  },
};
</script>



// WEBPACK FOOTER //
// Loading.vue?5d715c8f